import { Col, Row } from "react-bootstrap";
import { IComplianceInvestigationActionOrInstructionDetails } from "../../../../api/ComplianceInvestigation/IComplianceInvestigationActionsAndInstructions";
import EpaCard from "../../../../leap-components/EpaCard";
import EpaField from "../../../../leap-components/EpaField";
import EpaFieldHtml from "../../../../leap-components/EpaFieldHtml";

interface RequestForInformationDetailsProps {
  actionOrInstruction: IComplianceInvestigationActionOrInstructionDetails;
}

const ActionOrInstructionDetails = ({
  actionOrInstruction,
}: RequestForInformationDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Submitted by the EPA"}
            value={actionOrInstruction.datesubmitted}
          />
          <EpaField label={"Subject"} value={actionOrInstruction.subject} />
          <EpaField label={"Sender"} value={actionOrInstruction.sender} />
          <EpaField label={"Category"} value={actionOrInstruction.category} />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Licensee Response Due Date"}
            value={actionOrInstruction.duedate}
          />
          <EpaField label={"Type"} value={actionOrInstruction.type} />
          <EpaField label={"Recipient"} value={actionOrInstruction.recipient} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Action / Instruction Details (EPA Originated)"}
            value={actionOrInstruction.description}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return (
    <EpaCard title={"Action / Instruction Details"} content={bodyElements} />
  );
};

export default ActionOrInstructionDetails;
